import { createActionGroup, props } from '@ngrx/store';

export const authApiActions = createActionGroup({
  source: 'Auth API',
  events: {
    'Fetch Access Token Success': props<{ actorId: string; zendeskJWT: string }>(),
    'Fetch Access Token Failure': props<{ error: unknown }>(),
    'Send Passwordless Link Success': props<{ email: string }>(),
    'Send Passwordless Link Failure': props<{ error: unknown }>(),
  },
});
